<template>
  <div class="c-form container">
    <sm-event
      triggerHook="0.5"
      duration="100%"
      @onEnter="onEnter"
      @onLeave="onLeave"
      :offset="0"
      durationType="element"
      ref="smEvent"
    ></sm-event>
    <div class="row">
      <div class="col-11 col-md-12 mx-auto">
        <h3 class="section-title">CONTACT</h3>
        <p>弊社へのお問い合わせ、デザインのご依頼・ご質問は下記フォームからご連絡ください。</p>
      </div>
    </div>
    <div class="row">
      <form id="formapp" class="col-11 col-md-12 mx-auto" @submit="checkForm">
        <div class="form-sent" v-if="isSent">送信しました</div>
        <div class="form-errors" v-if="errors.length">
          <b>入力内容を再度ご確認ください</b>
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </div>
        <p ref="col_company">
          <label for="your-company">御社名／所属</label>
          <input id="your-company" v-model="company" type="text" name="your-company">
        </p>
        <p ref="col_name">
          <label class="required" for="your-name">お名前</label>
          <input id="your-name" v-model="name" type="text" name="your-name">
        </p>
        <p ref="col_email">
          <label class="required" for="your-email">E-mail</label>
          <input id="your-email" v-model="email" type="text" name="your-email">
        </p>
        <p ref="col_address">
          <label for="your-address">ご住所</label>
          <input id="your-address" v-model="address" type="text" name="your-address">
        </p>
        <p ref="col_number">
          <label for="your-number">電話番号</label>
          <input id="your-number" v-model="number" type="text" name="your-number">
        </p>
        <p ref="col_message">
          <label class="required" for="your-message">お問い合わせ内容</label>
          <textarea id="your-message" v-model="message" name="your-message" cols="30" rows="8"></textarea>
        </p>
        <p>
          <input type="submit" value="SEND">
        </p>
      </form>
    </div>
    <div class="row disclaimer">
      <p class="col-11 col-md-12 mx-auto">ご記載いただいた個人情報は、厳重に管理・保管し、お問い合わせのご返答およびご連絡のみに使用させていただきます。弊社Webサイトでご記載いただいた個人情報を、第三者に開示することはありません。<br>
      ご郵送先／恵比寿オフィス: 〒150-0013 東京都渋谷区恵比寿1-16-26 協和ビル102 P.K.G.Tokyo, Inc.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      isSent: null,
      errors: [],
      company: null,
      name: null,
      email: null,
      address: null,
      number: null,
      message: null
    }
  },
  methods: {
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    toggleError: function (target, state) {
      if (state) {
        target.classList.add('error')
      } else {
        target.classList.remove('error')
      }
    },
    checkForm: function (e) {
      const self = this
      e.preventDefault()
      this.errors = []

      // if (!this.company) {
      //   this.errors.push('御社名／所属を入力ください')
      //   this.toggleError(this.$refs.col_company, true)
      // } else {
      //   this.toggleError(this.$refs.col_company, false)
      // }
      if (!this.name) {
        this.errors.push('お名前を入力ください')
        this.toggleError(this.$refs.col_name, true)
      } else {
        this.toggleError(this.$refs.col_name, false)
      }
      if (!this.email) {
        this.errors.push('メールアドレスをを入力ください')
        this.toggleError(this.$refs.col_email, true)
      } else if (!this.validEmail(this.email)) {
        this.errors.push('正しいメールアドレスを入力ください')
        this.toggleError(this.$refs.col_email, true)
      } else {
        this.toggleError(this.$refs.col_email, false)
      }
      // if (!this.number) {
      //   this.errors.push('電話番号をを入力ください')
      //   this.toggleError(this.$refs.col_number, true)
      // } else {
      //   this.toggleError(this.$refs.col_number, false)
      // }
      if (!this.message) {
        this.errors.push('お問い合せ内容を入力ください')
        this.toggleError(this.$refs.col_message, true)
      } else {
        this.toggleError(this.$refs.col_message, false)
      }

      if (!this.errors.length) {
        var bodyFormData = new FormData()
        bodyFormData.set('your-company', this.company)
        bodyFormData.set('your-name', this.name)
        bodyFormData.set('your-email', this.email)
        bodyFormData.set('your-address', this.address)
        bodyFormData.set('your-number', this.number)
        bodyFormData.set('your-message', this.message)

        axios({
          method: 'post',
          url: this.$store.state.BlogArticle.url,
          data: bodyFormData,
          config: { headers: { 'Content-Type': 'multipart/form-data' } }
        })
          .then(function (response) {
            self.isSent = true
            return true
          })
          .catch(function (response) {
            console.error(response)
          })
      }
    },
    onEnter (event) {
      if (event.scrollDirection === 'FORWARD') {
        document.getElementsByClassName('c-mainmenu')[0].classList.add('hide')
      }
    },
    onLeave (event) {
      if (event.scrollDirection === 'REVERSE') {
        document.getElementsByClassName('c-mainmenu')[0].classList.remove('hide')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SectionForm.vue